var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"rotate(90 4 15.333)"},React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M9.417 0L10.667 1.25 5.333 6.583 0 1.25 1.25 0 5.333 4.083z"}))));
}

Left.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Left;

Left.default = Left;
